import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { HeroSection } from "@/components/sections/HeroSection";
import { FeaturedProjects } from "@/components/sections/FeaturedProjects";
import { AboutSection } from "@/components/sections/AboutSection";
import { SkillsGrid } from "@/components/sections/SkillsGrid";

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <FeaturedProjects />
      <AboutSection />
      <SkillsGrid />
      <CTASection />
    </>
  );
}

function CTASection() {
  return (
    <motion.section
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.4 }}
      className="mx-auto my-24 max-w-5xl px-4 sm:px-6"
    >
      <div className="relative overflow-hidden rounded-3xl border border-border bg-gradient-to-br from-primary/20 via-card to-card p-10 text-foreground shadow-xl">
        <div className="absolute inset-0 grid-pattern opacity-30" />
        <div className="relative">
          <h2 className="font-serif text-3xl sm:text-4xl">
            Have an idea worth shipping?
          </h2>
          <p className="mt-3 max-w-xl text-muted-foreground">
            I take on a small handful of freelance projects each quarter — NGO tooling,
            data platforms, and machine-learning integrations. Tell me about your project
            and I&apos;ll get back to you within a few days.
          </p>
          <Link
            to="/contact"
            className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-primary-foreground transition hover:opacity-90"
          >
            Start a conversation <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </div>
    </motion.section>
  );
}
